import { useApi } from '@/api';
import { ChartTimeFilter } from '@/components';
import { Flex, Card, ChartSkeleton, DisplaySwitch } from '@blockanalitica/ui';
import { useMemo, useState } from 'react';
import HistoricGraphs from './HistoricGraphs';

type HistoricData = {
  date: string;
  total_supply: string;
  total_borrow: string;
  health_rate: string;
  account_liquidity: string;
  liquidation_buffer: string;
};

export default function HistoricTabs({
  walletAddress
}: {
  walletAddress: string;
}) {
  const [activeDisplayOption, setActiveDisplayOption] =
    useState('total_supply');
  const [chartDaysAgo, setChartDaysAgo] = useState('30');
  const displayOptions = useMemo(
    () => [
      { key: 'total_supply', value: 'Supply' },
      { key: 'total_borrow', value: 'Borrow' },
      { key: 'health_rate', value: 'Health Rate' }
    ],
    []
  );

  const [data, error] = useApi<HistoricData[]>({
    url: `/wallets/${walletAddress}/historic/`,
    queryParams: {
      days_ago: chartDaysAgo
    }
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <ChartSkeleton />;
  }

  return (
    <Card gap="xs">
      <Flex
        justifyContent="space-between"
        alignItems={['center', 'flex-start']}
        flexDirection={['column', 'row']}
        gap={['xs', 'm']}>
        <DisplaySwitch
          data={displayOptions}
          activeOption={activeDisplayOption}
          onChange={setActiveDisplayOption}
        />
        <ChartTimeFilter
          activeOption={chartDaysAgo}
          onChange={setChartDaysAgo}
        />
      </Flex>
      <HistoricGraphs
        data={data}
        type={activeDisplayOption}
        chartDaysAgo={chartDaysAgo}
      />
    </Card>
  );
}
